import { render } from "./DevFolio.vue?vue&type=template&id=5abe042c&scoped=true"
import script from "./DevFolio.vue?vue&type=script&lang=js"
export * from "./DevFolio.vue?vue&type=script&lang=js"

import "./DevFolio.vue?vue&type=style&index=0&id=5abe042c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abe042c"]])

export default __exports__